import { Component, Input, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-prefixo',
  templateUrl: './text-prefixo.component.html',
  styleUrls: ['./text-prefixo.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextPrefixoComponent implements OnInit {

  constructor() { }

  ngOnInit() {}
}
